export const savePaymentMethod = (paymentMethod) => {
  return {
    type : 'SAVE_PAYMENT_METHOD',
    paymentMethod
  }
}; 
 